import { useState } from 'react'
import { Link } from 'react-router-dom'
import './BANTRef.css'

const BANTRef = () => {
  const [selectedProduct, setSelectedProduct] = useState('aisectraining')

  const products = [
    { id: 'aisectraining', name: 'AISecTraining' },
    { id: 'saas', name: 'SaaS Security Score' },
    { id: 'riskmanager', name: 'Risk Manager' },
    { id: 'securecodecards', name: 'Secure Code Cards' },
    { id: 'firewalli', name: 'Firewalli' }
  ]

  const getContent = (productId) => {
    if (productId === 'aisectraining') {
      return (
        <div className="bant-content">
          <p className="bant-icp-link">
            <Link to="/icp-hub?product=aisec">→ Full ICP Hub (AISec Training — qualification, messaging, channels)</Link>
          </p>
          <div className="bant-section">
            <h3>✅ Individual Subscriber</h3>
            
            <div className="bant-category">
              <h4>Budget</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Will pay personally</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Employer reimbursement planned</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Pricing tier acceptable</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Authority</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Self-decision maker</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>No approval required</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Need</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Certification prep</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>AI security upskilling</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Career advancement / role change</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Timeline</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Starting immediately</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Within 30 days</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Exam or deadline identified</span>
              </label>
            </div>

            <div className="bant-qualification">
              <strong>✔ Qualified if:</strong> Authority + Need + Timeline checked
            </div>
          </div>

          <div className="bant-section">
            <h3>✅ Enterprise Subscriber</h3>
            
            <div className="bant-category">
              <h4>Budget</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Training budget allocated</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Budget planned but not approved</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Procurement process identified</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Authority</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Decision maker</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Strong influencer</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Buying committee identified</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Need</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>AI governance / regulatory readiness</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Secure AI development capability</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Risk reduction / audit readiness</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Team upskilling / standardisation</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Timeline</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Pilot required</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Rollout in &lt; 3 months</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Rollout in 3–6 months</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Compliance or audit deadline</span>
              </label>
            </div>

            <div className="bant-qualification">
              <strong>✔ Qualified if:</strong> Need + Authority + Timeline checked (Budget confirmed or planned)
            </div>
          </div>
        </div>
      )
    } else if (productId === 'saas') {
      return (
        <div className="bant-content">
          <p className="bant-icp-link">
            <Link to="/icp-hub">→ Full ICP Hub (qualification, messaging, channels)</Link>
          </p>
          <div className="bant-section">
            <h3>✅ SaaS Security Score — Mid-Market / Enterprise</h3>

            <div className="bant-category">
              <h4>Budget</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Budget exists for security tooling</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Security / GRC owns budget or has approval path</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>CFO or procurement involved (budget pressure understood)</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Authority</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Security / GRC owns decision</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>CTO / CISO involved or influencer</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Head of Security, GRC Manager, Security Architect</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Need</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Replace spreadsheets for vendor/SaaS risk</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>SOC 2 / ISO 27001 required or planned</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Audit within 6 months</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>No clear SaaS data residency view</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>No unified incident tracking for SaaS</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Customer security questionnaires increasing</span>
              </label>
            </div>

            <div className="bant-category">
              <h4>Timeline</h4>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Audit scheduled within 3–6 months</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Recent vendor incident / breach / compliance finding</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>Rapid SaaS sprawl (growth, M&A, remote work)</span>
              </label>
              <label className="bant-checkbox">
                <input type="checkbox" />
                <span>New GRC hire needing structure fast</span>
              </label>
            </div>

            <div className="bant-qualification">
              <strong>✔ Qualified if:</strong> Firmographic fit (50–1,000 employees, 30+ SaaS) + Authority + Need + Timeline
            </div>
            <div className="bant-qualification bant-disqualify">
              <strong>✗ Disqualify if:</strong> &lt;20 employees; wants vuln scanning/EDR replacement; no compliance or governance requirements
            </div>
          </div>
        </div>
      )
    } else {
      // Placeholder for other products
      return (
        <div className="bant-placeholder">
          <p>BANT checklist content for <strong>{products.find(p => p.id === productId)?.name}</strong> coming soon.</p>
        </div>
      )
    }
  }

  return (
    <div className="bant-ref-page">
      <div className="page-header">
        <div>
          <h2>BANT Reference</h2>
          <p className="subtitle">Budget, Authority, Need, Timeline qualification checklist</p>
        </div>
      </div>

      <div className="product-selector">
        {products.map(product => (
          <button
            key={product.id}
            className={`product-tab ${selectedProduct === product.id ? 'active' : ''}`}
            onClick={() => setSelectedProduct(product.id)}
          >
            {product.name}
          </button>
        ))}
      </div>

      <div className="bant-container">
        {getContent(selectedProduct)}
      </div>
    </div>
  )
}

export default BANTRef

